export type IApiGetDemoDataParam = any;

export enum MediaType {
    FOLDER = 'FOLDER',
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
    AUDIO = 'AUDIO',
    DOCUMENT = 'DOCUMENT',
    OTHER = 'OTHER',
    FILE = 'FILE',
}

export interface IMediaItem {
    id: string;
    name: string;
    path: string;
    type: MediaType;
    size: number | null;
    url: string;
    children?: IMediaItem[] | null;
    duration?: number;
}
export interface IListLibraryMediaResponse {
    path: string;
    items : IMediaItem[];
}

export interface IApiGetLibraryMediaParam { 
    keySearch?: string;
    page: number;
    size: number;
}
export interface IAddMediaLinkPayload {
    id?: string;
    name: string;
    urlLink: string;
    typeLink?: string;
    path: string;
}

export interface ILink {
    id: string;
    name: string;
    urlLink: string;
    typeLink: string;
    createdDate: string;
    duration?: number;
}